export const MINUTE_MS = 600;
